var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 20.9167C14.2852 20.9167 17.0834 18.1184 17.0834 14.6667C17.0834 11.2149 14.2852 8.41666 10.8334 8.41666C7.38159 8.41666 4.58337 11.2149 4.58337 14.6667C4.58337 18.1184 7.38159 20.9167 10.8334 20.9167Z",
    fill: "#B5A2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 21.4833C15.0621 23.8936 13.7458 27.1305 13.75 30.5V30.5667H5.53338C4.61631 30.564 3.7378 30.1974 3.0909 29.5474C2.44399 28.8973 2.08161 28.0171 2.08338 27.1C2.08222 25.5088 2.53473 23.9503 3.38784 22.6072C4.24095 21.2641 5.4593 20.192 6.90005 19.5167C8.02062 18.9675 9.25214 18.6824 10.5 18.6833H11.1667C12.4146 18.6824 13.6461 18.9675 14.7667 19.5167C15.7783 19.9789 16.6812 20.649 17.4167 21.4833Z",
    fill: "#B5A2FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 21.75C31.0389 21.75 34.5833 18.2056 34.5833 13.8333C34.5833 9.46108 31.0389 5.91666 26.6667 5.91666C22.2944 5.91666 18.75 9.46108 18.75 13.8333C18.75 18.2056 22.2944 21.75 26.6667 21.75Z",
    fill: "#523FC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 19.25C23.6841 19.2535 20.8247 20.4399 18.7157 22.5489C16.6067 24.658 15.4203 27.5174 15.4167 30.5V30.7567C15.4167 31.3257 15.5288 31.8892 15.7466 32.415C15.9644 32.9407 16.2836 33.4184 16.686 33.8208C17.0883 34.2232 17.566 34.5424 18.0918 34.7601C18.6175 34.9779 19.181 35.09 19.7501 35.09H33.5967C34.1658 35.09 34.7293 34.9779 35.255 34.7601C35.7808 34.5424 36.2585 34.2232 36.6609 33.8208C37.0633 33.4184 37.3825 32.9407 37.6002 32.415C37.818 31.8892 37.9301 31.3257 37.9301 30.7567V30.5C37.9265 27.5151 36.7383 24.6536 34.6264 22.5442C32.5145 20.4348 29.6517 19.25 26.6667 19.25Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active-users.a320ca1e97f51d67c6792b89c2d392a2.svg";
export { ForwardRef as ReactComponent };